import type { BuriedPointType } from '@opm/operationLog/buriedPoint';
import { typeIdObj } from '@/pages/home/utils/buriedPoint';

/** Studio 嵌入 Marketing 页时传入的 logConfig（与 tabs[].logConfig 对齐） */
export interface IStudioEmbedLogConfig {
  enabled?: boolean;
  pageId?: string;
  pageName?: string;
  pagePath?: string;
  extInfo?: string;
}

/**
 * Studio 嵌入场景：仅覆盖 DBOM_POINT 上下文中的页面与 FilterSubmit 按钮字段。
 * 未传 studioLogConfig 时原样返回 marketingPoint，Marketing 原路由不受影响。
 *
 * 按钮规则：FilterSubmit.buttonId = `${pageId}001`（与 Studio 页面打点 pageId 对齐）
 */
export function mergeMarketingBuriedPointForStudio(
  marketingPoint: BuriedPointType,
  studioLogConfig?: IStudioEmbedLogConfig,
): BuriedPointType {
  if (!studioLogConfig?.pageId) {
    return marketingPoint;
  }

  const { pageId, pageName, pagePath } = studioLogConfig;

  return {
    ...marketingPoint,
    pageId,
    pageName: pageName || marketingPoint.pageName,
    pagePath: pagePath || marketingPoint.pagePath,
    common: {
      ...marketingPoint.common,
      typeId: typeIdObj.studio,
      source: 0,
    },
    button: {
      ...marketingPoint.button,
      FilterSubmit: {
        buttonId: `${pageId}001`,
      },
    },
  };
}
